import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'update-team-member-details-dialog',
    styleUrls: ['./update-team-member-details-dialog.component.css'],
    templateUrl: 'update-team-member-details-dialog.component.html',
    standalone: false
})
export class UpdateTeamMemberDialogComponent {
  teamMemberDetailsForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<UpdateTeamMemberDialogComponent>,
    @Inject(FormBuilder) private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { 
      name: string; 
      email: string; 
      phoneNumber: string;
      smsNotifications: boolean;
      emailNotifications: boolean;
      voiceCallNotifications: boolean;
     }
  ) {
    this.teamMemberDetailsForm = this.fb.group({
      name: [{ value: data.name, disabled: true }],
      email: [{ value: data.email, disabled: true }],
      phoneNumber: [data.phoneNumber, [Validators.required, Validators.minLength(10), Validators.maxLength(10)]],
      smsNotifications: [data.smsNotifications],
      emailNotifications: [data.emailNotifications],
      voiceNotifications: [data.voiceCallNotifications]
    });
  }

  saveTeamMember(): void {
    if (this.teamMemberDetailsForm.valid) {
      this.dialogRef.close({ 
        name: this.data.name, 
        email: this.data.email, 
        phoneNumber: this.teamMemberDetailsForm.get('phoneNumber')!.value,
        smsNotificationsEnabled: this.teamMemberDetailsForm.get('smsNotifications')!.value,
        emailNotificationsEnabled: this.teamMemberDetailsForm.get('emailNotifications')!.value,
        voiceCallNotificationsEnabled: this.teamMemberDetailsForm.get('voiceNotifications')!.value
      });
    }
  }

  atLeastOneContactMethodEnabled(): boolean {
    return this.teamMemberDetailsForm.get('smsNotifications')!.value || 
    this.teamMemberDetailsForm.get('emailNotifications')!.value || 
    this.teamMemberDetailsForm.get('voiceNotifications')!.value;
  }

  close(confirmed: boolean): void {
    this.dialogRef.close(confirmed);
  }
}
